export enum Role { // todo: remove and use from generated api
  SR_INVESTOR = 'sr_investor',
  SR_ISSUER = 'sr_issuer',
  SR_ISSUER_ADMIN = 'sr_issuer_admin',
  SR_ADMIN = 'sr_admin',
  COMPLIANCE_ADMIN = 'compliance_admin',
  COMPLIANCE_USER = 'compliance_user',
  ACADEMY_USER = 'academy_user',
  ACADEMY_ORGANISATION_ADMIN = 'academy_organisation_admin',
}
